<script setup lang="ts">
import { onMounted } from 'vue'
import SiteBlockedNotice from '@/components/layout/SiteBlockedNotice.vue'
import GlobalGates from '@/layouts/GlobalGates.vue'
import { useSiteStore } from '@/stores/site'

/**
 * 應用外殼。
 *
 * 刻意保持極簡 —— 版面屬於 `layouts/`，內容屬於 `views/`。
 * T1 的 `App.vue` 有 415 行，塞了第三方登入回呼、全域事件、面板切換等邏輯。
 *
 * 這裡唯一多做的一件事是**站台閘門**：站台維護或停用時，
 * 後端每一支 API 都會回 503，讓使用者進得去只會看到一堆載入失敗。
 * 這是全站唯一該擋在 `RouterView` 之前的東西，所以放在這一層。
 *
 * `GlobalGates` 是**擋在 RouterView 之上**（不是之前）的兩個對話框：
 * 先登入、進遊戲確認。放在這一層是因為遊戲頁掛在 `DefaultLayout` 外面，
 * 而 session 可能在任何一頁失效 —— 版面裡放不到每一種情況。
 */
const site = useSiteStore()

onMounted(() => {
  void site.load()
})
</script>

<template>
  <SiteBlockedNotice
    v-if="site.blockedStatus !== null"
    :status="site.blockedStatus"
    :site-name="site.site?.name ?? ''"
    :retrying="site.isLoading"
    @retry="site.load()"
  />

  <RouterView v-else />

  <!-- 站台被擋下時不掛：那個畫面上沒有任何需要登入才能做的事 -->
  <GlobalGates v-if="site.blockedStatus === null" />
</template>
